
export class UserDataUserModel {
    id = ''
    code = ''
    email = ''
}
export class UserDataPreferencesModel {
    contactName = ''
    contactPhone = ''
    receivePromotions = false
    receiveNews = false
}
export class CustomerLoyaltyModel {
    customerLevel = 3
    ritmitosAvailable = 0
    ritmitosInOrders = 0
}
export default class UserDataModel {
    token = ''
    user: UserDataUserModel = new UserDataUserModel()
    preferences: UserDataPreferencesModel = new UserDataPreferencesModel()
    invoices: any[] = []
    orders: any[] = []
    isActive = false
    loyalty:CustomerLoyaltyModel = new CustomerLoyaltyModel()
}